import React, { useEffect, useState } from "react";
import "./Home.css";
import restaurantsData from "./restaurants.json";

export default function Home() {
  const [restaurants, setRestaurants] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("All Countries");
  const [selectedTier, setSelectedTier] = useState("All Tiers");
  const [search, setSearch] = useState("");

  useEffect(() => {
    const sortedData = [...restaurantsData].sort((a, b) => a.placement - b.placement);
    setRestaurants(sortedData);
  }, []);

  const countries = ["All Countries", ...new Set(restaurantsData.map(r => r.country).filter(Boolean))];
  const tiers = ["All Tiers", ...new Set(restaurantsData.map(r => r.tier).filter(t => t !== undefined))];

  const passSearch = (r) => {
    const lower = search.toLowerCase()
    return r.country.toLowerCase().includes(lower)
        || r.city.toString().toLowerCase().includes(lower)
        || r.review.toString().toLowerCase().includes(lower)
        || r.restaurant_name.toString().toLowerCase().includes(lower)
        || r.cuisine.toString().toLowerCase().includes(lower)
        || (r.datemonth.toString() +','+ r.dateyear.toString()).includes(lower)
  }

  const filteredRestaurants = restaurants.filter(r => {
    const countryMatch = selectedCountry === "All Countries" || r.country === selectedCountry;
    const tierMatch = selectedTier === "All Tiers" || r.tier.toString() === selectedTier.toString();
    return countryMatch && tierMatch && passSearch(r);
  });


  return (
    <div className="home-container">
      <h1 className="home-title">Alan's Food Guide</h1>

      <div className="filter-bar">
        {/* <label htmlFor="country-select">Filter by Country:</label> */}
        <select
          id="country-select"
          value={selectedCountry}
          onChange={(e) => setSelectedCountry(e.target.value)}
        >
          {countries.map((country, index) => (
            <option key={index} value={country}>{country}</option>
          ))}
        </select>

        {/* <label htmlFor="tier-select">Filter by Tier:</label> */}
        <select
          id="tier-select"
          value={selectedTier}
          onChange={(e) => setSelectedTier(e.target.value)}
        >
          {tiers.map((tier, index) => (
            <option key={index} value={tier}>{tier}</option>
          ))}
        </select>

        <input
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search here"
        >
          
        </input>

        <div>
          Showing <b>{filteredRestaurants.length}</b> / {restaurants.length} restaurants
        </div>
      </div>

      

      <div className="restaurant-grid">
        {filteredRestaurants.map((restaurant, index) => (
          <div
          className={`card flashy-tier-${restaurant.tier} restaurant-card`}
          key={index}
          style={{ "--i": index }}
        >
        
            <a href={`/review/${restaurant.nickname}`} target="_blank" rel="noopener noreferrer">
              <div className={`image-wrapper ${restaurant.michelinlink !== "." ? "michelin-glow" : ""}`}>
                <img
                  src={`./images/${restaurant.nickname}.jpg`}
                  alt={restaurant.restaurant_name}
                  className="restaurant-image"
                />
                {restaurant.michelinlink !== "." && (
                  <img src="./images/michelinguide.svg" alt="Michelin Guide" className="michelin-icon" />
                )}
              </div>
            </a>
            <h2 className="restaurant-name-formatted">{restaurant.restaurant_name}</h2>
            <p className="restaurant-location">
              {restaurant.city || "City"}, {restaurant.country || "Country"}
            </p>
            <p className="restaurant-meta">
              {"$".repeat(restaurant.price || 1)} | {restaurant.cuisine || "Cuisine"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
